const colorArry = ['#B5C9F7', '#C8B5F7', '#8EE38E', '#B5C9F7', '#C8B5F7', '#8EE38E'];
const alphabetSetOne = 'abcd';
const alphabetSetTwo = 'efgh';
const alphabetSetThree = 'ijkl';
const alphabetSetFour = 'mnop';
const alphabetSetFive = 'qrst';
const alphabetSetSix = 'uvwxyz';

export default function getRandomColor(intial) {
  if (alphabetSetOne.includes(intial.toLowerCase())) {
    return colorArry[0];
  } else if (alphabetSetTwo.includes(intial.toLowerCase())) {
    return colorArry[1];
  } else if (alphabetSetThree.includes(intial.toLowerCase())) {
    return colorArry[2];
  } else if (alphabetSetFour.includes(intial.toLowerCase())) {
    return colorArry[3];
  } else if (alphabetSetFive.includes(intial.toLowerCase())) {
    return colorArry[4];
  } else if (alphabetSetSix.includes(intial.toLowerCase())) {
    return colorArry[5];
  }

  return colorArry[Math.floor(Math.random() * colorArry.length)];
}




// WEBPACK FOOTER //
// ./src/js/libs/Random.js